/**
 * RS pool lines — the per-member split of one deal's roof-team pool, in the
 * shape BOTH `rs_pool_mark_paid` (Shannon's legacy mark-paid) and
 * `rs_pool_approve` (Oct 8, 2026: the approval that makes the Books bills)
 * take. One place for the math so the pool a person is paid is the pool the
 * board rendered: commissionable revenue × 1.5% × the member's share, rounded
 * to the cent per line, zero / inactive shares dropped.
 */

/** 1.5 % — single source of truth for the pool rate. */
export const RS_POOL_RATE_LIVE = 0.015;

export interface RsPoolMemberShare {
  team_member_id: string;
  share: number | null;
}

export interface RsPoolLine {
  deal_id: string;
  member_id: string;
  share: number;
  amount: number;
  rev: number;
  rate: number;
}

function round2(n: number): number {
  return Math.round(n * 100) / 100;
}

/**
 * The pool lines for one deal. `rev` is the deal's commissionable revenue (the
 * same figure the RM commission is computed on); `pool` is the active
 * `rs_pool_members` rows (status = 'active').
 */
export function rsPoolLinesFor(dealId: string, rev: number, pool: RsPoolMemberShare[]): RsPoolLine[] {
  const revR = round2(rev);
  const poolTotal = rev * RS_POOL_RATE_LIVE;
  return pool
    .map((pm) => ({
      deal_id: dealId,
      member_id: pm.team_member_id,
      share: Number(pm.share ?? 0),
      amount: round2(poolTotal * Number(pm.share ?? 0)),
      rev: revR,
      rate: RS_POOL_RATE_LIVE,
    }))
    .filter((l) => l.share > 0 && l.amount >= 0.005);
}
